// extracted by mini-css-extract-plugin
export default {"strip":"EnvBadge_strip__jT2iX","pill":"EnvBadge_pill__7vy2O","preprod":"EnvBadge_preprod__y0hqM","stag":"EnvBadge_stag__RlfTo"};